import React from "react";
import { useTranslation } from "react-i18next";
import ErrorMessage from "./ErrorMessage";

const AsaAccessError = (props) => {
  const { t } = useTranslation();

  return (
    <ErrorMessage
      showAppBar={false}
      messageType="security"
      message={t("messages.common.errors.couldNotAccessADGroup")}
    />
  );
};

export default AsaAccessError;
